document.addEventListener('DOMContentLoaded', function() {
    // Handle wishlist icon clicks for adding/removing from wishlist
    const wishlistIcons = document.querySelectorAll('.wishlist-icon');

    // Function to update the state of wishlist icons based on localStorage
    function updateWishlistIcons() {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        wishlistIcons.forEach(icon => {
            const productHandle = icon.dataset.productHandle;
            if (wishlist.includes(productHandle)) {
                icon.classList.add('active');
            } else {
                icon.classList.remove('active');
            }
        });
    }

    wishlistIcons.forEach(icon => {
        icon.addEventListener('click', function() {
            const productHandle = this.dataset.productHandle;
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

            if (wishlist.includes(productHandle)) {
                wishlist = wishlist.filter(handle => handle !== productHandle);
                this.classList.remove('active');
                showNotification('Product removed from wishlist');
            } else {
                wishlist.push(productHandle);
                this.classList.add('active');
                showNotification('Product added to wishlist');
            }

            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            updateWishlistCount();
        });
    });

    // Function to display notifications
    function showNotification(message) {
        const notificationBox = document.createElement('div');
        notificationBox.className = 'notification-box';
        notificationBox.innerText = message;
        document.body.appendChild(notificationBox);
        setTimeout(() => notificationBox.remove(), 3000);
    }

    // Function to update wishlist count
    function updateWishlistCount() {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const count = wishlist.length;
        document.querySelector('.wishlist-count').innerText = count;
    }

    // Initial count and icon state update
    updateWishlistCount();
    updateWishlistIcons();

    // Load wishlist items on page load
    const wishlistItemsContainer = document.querySelector('.wishlist-items');

    if (wishlistItemsContainer) {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        
        if (wishlist.length > 0) {
            wishlist.forEach(productHandle => {
                fetch(`/products/${productHandle}.js`)
                    .then(response => response.json())
                    .then(product => {
                        // Extract price and format it
                        const price = (product.variants[0].price / 100).toFixed(2);

                        // Append each wishlist item without "Add to Cart" button
                        wishlistItemsContainer.innerHTML += `
                        <div class="wishlist-item" id="item-${productHandle}">
                            <div class="wishlist-item-image">
                                <img src="${product.images[0]}" alt="${product.title}" class="wishlist-image">
                            </div>
                            <div class="wishlist-item-details">
                                <h3 class="wishlist-product-title">${product.title}</h3>
                                <p class="wishlist-product-price">${price} ${Shopify.currency.active}</p>
                                <p class="wishlist-product-stock-status">In Stock</p>
                                <div class="wishlist-item-buttons">
                                    <a href="/products/${productHandle}" class="wishlist-view-product-button">View Product</a>
                                    <button class="wishlist-remove-from-wishlist-button" data-product-handle="${productHandle}">X</button>
                                </div>
                            </div>
                        </div>
                        `;
                    })
                    .catch(error => console.error('Error fetching product data:', error));
            });
        } else {
            wishlistItemsContainer.innerHTML = '<p style="text-align: center; font-weight: bold; margin-top: 50px;">"Your wishlist is feeling a little lonely 💔 Add something cute to keep it company!"</p>';
        }

        // Add event listener for remove buttons
        wishlistItemsContainer.addEventListener('click', function(event) {
            if (event.target.classList.contains('wishlist-remove-from-wishlist-button')) {
                const productHandle = event.target.dataset.productHandle;
                removeFromWishlist(productHandle);
                // Remove the wishlist item from the DOM
                const itemElement = document.getElementById(`item-${productHandle}`);
                if (itemElement) {
                    itemElement.remove();
                }
                updateWishlistCount();
                // Check if the wishlist is empty after removing an item
                const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
                if (wishlist.length === 0) {
                    wishlistItemsContainer.innerHTML = '<p style="text-align: center; font-weight: bold; margin-top: 50px;">"Your wishlist is feeling a little lonely 💔 Add something cute to keep it company!"</p>';
                }
            }
        });
    }

    // Function to remove item from wishlist in localStorage
    function removeFromWishlist(productHandle) {
        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        wishlist = wishlist.filter(handle => handle !== productHandle);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }

    // Function to update wishlist count
    function updateWishlistCount() {
        const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const count = wishlist.length;
        document.querySelector('.wishlist-count').innerText = count;
    }

    // Initial count update
    updateWishlistCount();
});
